import { graphql } from 'react-apollo'
import { Layout, Table } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'

import summaryQuery from '../graphql/queries/labelSummary'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'

const { Content } = Layout

const LabelSummary = (props) => {
  const { summary: { loading, labelSummary: summary = [] } } = props
  const columns = [
    {
      title: 'Group',
      dataIndex: 'group',
      key: 'group',
    },
    {
      title: 'Count',
      dataIndex: 'count',
      key: 'count',
      width: 150,
      className: 'text-right',
    },
    {
      title: 'Tracking',
      dataIndex: 'tracking',
      key: 'tracking',
      width: 150,
      className: 'text-right',
    },
  ]
  return (
    <Layout>
      <Navbar selected="label:4" />
      <Content style={{ padding: '0 20px' }}>
        <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
          <h2>Label Summary</h2>
          <Table
            dataSource={summary}
            columns={columns}
            rowKey="group"
            pagination={{ pageSize: 50 }}
            size="middle"
            loading={loading}
            bordered
          />
        </div>
      </Content>
      <Footer />
    </Layout>
  )
}
LabelSummary.propTypes = {
  summary: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    summary: PropTypes.array,
  }).isRequired,
}
LabelSummary.defaultProps = {}

export default graphql(summaryQuery, { name: 'summary' })(LabelSummary)



// WEBPACK FOOTER //
// ./src/pages/LabelSummary.js